import Common from '../../Common';

interface PostBody {
	field: string
	type: 'mobile' | 'work' | 'home' | 'number' | 'email' | 'custom' | 'tag'
	label: string
}

const Field = class extends Common {
	browse = (contactId: id) =>
		this.get(`/contact/${contactId}/field`)

	read = (contactId: id, fieldId: id) =>
		this.get(`/contact/${contactId}/field/${fieldId}`)

	delete = (contactId: id, fieldId: id) =>
		this.doDelete(`/contact/${contactId}/field/${fieldId}`)

	create = (contactId: id, body: PostBody) =>
		this.post(`/contact/${contactId}/field`, body)

	update = (contactId: id, fieldId: id, body: PostBody) =>
		this.patch(`/contact/${contactId}/field/${fieldId}`, body)
}

export default Field
